import React from "react";

const ContactHero = () => {
  return (
    <div className="max-w-[1920px] 2xl:h-[530px] lg:h-[510px] md:h-[440px] sm:h-[400px] h-[250px] mx-auto bg-cover bg-center bg-no-repeat bg-airplane"></div>
  );
};

export default ContactHero;
